import type { TFunction } from "i18next";
import type { Stage } from "@/types/application";

// name is the English snapshot Greenhouse synced; keep it as the fallback for
// name_keys added upstream before this app knows their translation.
export const stageName = (
  { name, name_key }: Pick<Stage, "name" | "name_key">,
  t: TFunction,
): string => (name_key ? t(`stage_names.${name_key}`, name) : name);
